import classNames from 'classnames';
import {Link} from 'react-router';
import React from 'react';

import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';
import {Menu} from '@albert-io/atomic';

interface BaseProps extends PropsWithChildrenRequired, PropsWithClassNameOptional {
  icon?: IconProp;
}

interface PropsWithTo extends BaseProps {
  onClick?: never;
  selected?: boolean;
  to: string;
}

interface PropsWithOnclick extends BaseProps {
  onClick: () => void;
  selected?: never;
  to?: never;
}

type Props = PropsWithOnclick | PropsWithTo;

export default function StudentHomepageSidebarItem({
  children,
  className,
  icon,
  onClick,
  selected = false,
  to
}: Props) {
  return (
    <Menu.Item
      as={to !== undefined ? Link : undefined}
      className={classNames('px-x2! py-x1-half! no-underline', className)}
      leftIconProps={icon !== undefined ? {icon} : undefined}
      onClick={onClick}
      preventDefaultClickHandler={false}
      selected={selected}
      to={to !== undefined ? to : ''}
    >
      {children}
    </Menu.Item>
  );
}
